import React from 'react';
import '../../styles/table-main/main.css';
import { Link } from 'react-router-dom';

const Main = () => {
    return (
        <>
            <div className="table-main">
                            <div className="container mt-5 mb-5 admin-container">
                                <div className="row">
                                    <div className="col-md-12 pull-left flip sm-pull-none">
                                        <div className="admin-table">
                                            <h2 className="my-heading">Biotechnology Ph.D Students</h2>
                                            {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                            <div className="table-scrollable">
                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Name of Researcher</th>
                                                            <th>Title</th>
                                                            <th>Supervisor</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
        </>
    )
}

export default Main;